<template>
  <div class="editruleMain common-form-content">
    <el-form :model="formData" ref="form" size="normal">
      <div class="form-content form-top">
        <el-form-item :inline="true" label="规则名称" required>
          <el-input
              v-model="formData.changeName"
              placeholder="请输入计费规则名称"
              maxlength="20"
              show-word-limit
          ></el-input>
        </el-form-item>
      </div>
      <div class="tips-box">
        <div class="title"><span>*</span>费用设置</div>
        <div class="desc">
          注：峰、平、谷时段价格均为必填项。因各地电价不同，请根
          据当地实际 电价填写。
        </div>
      </div>


      <div class="form-content form-cart">
        <div class="form-item-rule-box"
             v-for="(item, index) in priceTypeList"
             :key="index"
        >
          <div class="form-item-rule_label">{{ item.txt }}</div>
          <div class="form-item-rule_body">
            <div class="form-item-rule_item">
              <div class="form-item-rule_item_label">电费（元/度）</div>
              <div class="form-item-rule_tem_value">
                <!-- <el-input
                    type="number"
                    v-model="item.price"
                    placeholder="请输入"
                ></el-input> -->
                 <el-input-number ref="priceInput" v-model="item.price" :controls="false" :precision="4" :min="0.0" :max="100" :step="0.01"
              style="width: 120px; margin-right: 10px"></el-input-number>
              </div>
            </div>
            <div class="form-item-rule_item">
              <div class="form-item-rule_item_label">服务费（元/度）</div>
              <div class="form-item-rule_tem_value">
              <!--   <el-input
                    type="number"
                    v-model="item.servicePrice"
                    placeholder="请输入"
                ></el-input> -->
                <el-input-number ref="servicePriceInput" v-model="item.servicePrice" :controls="false" :precision="4" :min="0.0" :max="100" :step="0.01"
              style="width: 120px; margin-right: 10px"></el-input-number>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips-box">
        <div class="title"><span>*</span>24小时尖峰平谷分布设置</div>
        <div class="desc">
          注：时间设置最小间隔为30分钟；最多可设置48个计费时段。
        </div>
      </div>
      <div class="form-content form-cart form-box-time-box">
        <div class="time-title-box">
          <div class="item" style="padding-left: 0.1rem">时段</div>
          <div class="item">开始时间</div>
          <div class="item">结束时间</div>
        </div>
        <div
            v-for="(item, index) in formData.priceList"
            :key="index"
            :style="index == 0 ? 'margin-top: 0;' : ''"
            class="time-item">
          <div class="before">
            <div class="select-key">
              <el-select
                  class="label"
                  v-model="item.priceType"
                  placeholder="费用类型"
                  @focus="selectFun(index)"
                  style="width: 4rem;"
              >
                <el-option
                    v-for="(type, index) in priceTypeList"
                    :key="index"
                    :label="type.txt"
                    :value="type.priceType"
                ></el-option>
              </el-select>
              <img class="icon" src="@/assets/image/icon/lower.png"/>
            </div>
            <div class="time-picker">
              <div class="time-picker-item disabled-item">
                <img class="icon" src="@/assets/image/icon/time.png">
                <el-time-select
                    class="value"
                    placeholder="开始时间"
                    v-model="item.startTime"
                    :picker-options="pickerOptions"
                    :class="item.classStartTime"
                    :clearable="false"
                ></el-time-select>
              </div>
              <div class="time-picker-item" :class="{'disabled-item': index == formData.priceList.length - 1}"
                   style="padding-left: 0.5rem;">
                <img class="icon" style="margin-right: 0" src="@/assets/image/icon/time.png">
                <el-time-select
                    class="value"
                    placeholder="结束时间"
                    v-model="item.endTime"
                    :picker-options="{
                      start: index > 0 ? addTime30(item.startTime) : '00:30',
                      step: '00:30',
                      end: '23:30',
                    }"
                    style="width: 4rem;margin-left: 0.32rem;"
                    @click.native="
                      endTimeSelect(index, item.startTime, item.endTime)
                    "
                    :clearable="false"
                ></el-time-select>
              </div>
              <img class="after-icon" src="@/assets/image/icon/lower.png"/>
            </div>
          </div>
          <div class="after"
               :class="{'is-one': !(index != 0 && index != formData.priceList.length - 1)}">

            <div class="operate-btn"
                 @click="minusPrice(index)"
                 v-if="index != 0 && index != formData.priceList.length - 1">删除
            </div>
            <div class="operate-btn"
                 @click="plusPrice(index)"
                 v-if="(index != formData.priceList.length - 1 &&
                      item.endTime != '23:30') ||
                      index == 0">
              <i class="el-icon-plus"></i>
              添加
            </div>
          </div>
        </div>
      </div>
      <div class="form-sub-box">
        <div class="submit-btn" :class="{'is-submit-state': submitBtnState}"
             @click="confimHandler">
          保存
        </div>
      </div>
    </el-form>
    <nut-picker
        :is-visible="pickerVisible"
        :list-data="listData"
        :default-value-data="defaultValueData"
        @close="pickerClose()"
        @confirm="pickerConfirm"
    ></nut-picker>
    <!-- <nut-datepicker :is-visible="datePickerVisible" type="time" title="请选择时间" @close="switchPicker()"
            :is-use12-hours="false" :defaultValue="timeDefaultValue" :is-am="false" @choose="dateChoose"
            :startHour="startHour" :endHour="endHour"
            >
        </nut-datepicker> -->
    <van-action-sheet v-model="datePickerVisible" :title="''">
      <van-datetime-picker
          type="time"
          title="选择时间"
          :min-hour="startHour"
          :max-hour="endHour"
          @confirm="dateChoose"
          @cancel="switchPicker"
          :filter="timeFilter"
          v-model="currentTime"
      />
    </van-action-sheet>


  </div>
</template>
<script>
import {getRulePriceList, editRule, addRule} from "@/api/newApi";
import {Toast} from "vant";

export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      currentTime: "",
      createtime: "",
      startTimeIndex: null,
      endTimeIndex: null,
      startHour: 1,
      endHour: 23,
      pickerOptions: {start: "00:30", step: "00:30", end: "23:30"},
      priceType: null,
      priceIndex: null,
      timeDefaultValue: null,
      defaultValueData: null,
      listData: [],
      datePickerVisible: false,
      pickerVisible: false,
      priceTypeName: "",
      submitBtnState: false,
      formData: {
        cardNo: "",
        mobile: "",
        sum: 0,
        chargeType: "",
        ruleType: "",
        changeName: "",
        isGive: "",
        isSysGive: "",
        userId: "",
        priceList: [],
      },
      priceTypeList: [
        {
          id: "",
          priceType: 0,
          price: 1.44,
          servicePrice: 0.8,
          txt: "尖时段",
          cor: "#B1320D",
          bgcor: "#FFE0D7",
        },
        {
          id: "",
          priceType: 1,
          price: 1.44,
          servicePrice: 0.8,
          txt: "峰时段",
          cor: "#064891",
          bgcor: "#D7EAFF",
        },
        {
          id: "",
          priceType: 2,
          price: 0.695,
          servicePrice: 0.8,
          txt: "平时段",
          cor: "#203096",
          bgcor: "#E6E8F5",
        },
        {
          id: "",
          priceType: 3,
          price: 0.3946,
          servicePrice: 0.8,
          txt: "谷时段",
          cor: "#444444",
          bgcor: "#F3F3F3",
        },
      ],
      formRule: {
        changeName: [
          {required: true, message: "请输入必填项", trigger: "blur"},
        ],
      },
      priceList: [
        {
          price: 0.3946,
          priceType: 3,
          servicePrice: 0.8,
          startTime: "00:00",
          endTime: "08:00",
          classStartTime: "",
          classEndTime: "",
        },
        {
          price: 0.695,
          priceType: 2,
          servicePrice: 0.8,
          startTime: "08:00",
          endTime: "10:00",
          classStartTime: "",
          classEndTime: "",
        },
        {
          price: 1.0044,
          priceType: 1,
          servicePrice: 0.8,
          startTime: "10:00",
          endTime: "13:00",
          classStartTime: "",
          classEndTime: "",
        },
        {
          price: 1.0044,
          priceType: 0,
          servicePrice: 0.8,
          startTime: "13:00",
          endTime: "24:00",
          classStartTime: "",
          classEndTime: "",
        },
      ],
    };
  },
  computed: {},
  watch: {
    'formData.changeName'(val) {
      if (val) {
        this.submitBtnState = true;
      } else {
        this.submitBtnState = false;
      }
    },
  },
  mounted() {
    this.listData = [
      this.priceTypeList.map((item) => {
        return {
          label: item.priceType,
          value: item.txt,
        };
      }),
    ];
    if (this.$route.query.changeName) {
      this.formData.changeName = this.$route.query.changeName;
      this.getRuleTitme();
    } else {
      this.formData = {
        changeName: "",
        priceList: [...this.priceList],
      };
    }
    if (this.$route.query.createtime) {
      this.createtime = this.$route.query.createtime;
    }
    console.log(this.listData);
  },
  methods: {
    timeFilter(type, options) {
      return options.filter((option) => {
        if (type === "minute") {
          return option == 0 || option == 30;
        } else if (type === "hour") {
          return option;
        }
      });
      return options;
    },
    statTimeSelect(index) {
      this.startTimeIndex = index;
      this.datePickerVisible = true;
    },
    endTimeSelect(index, startTime, endTime) {
      if (index != (this.formData.priceList.length - 1)) {
        this.startHour = parseInt(startTime);
        this.endHour = 23;
        this.endTimeIndex = index;
        this.currentTime = endTime;
        this.datePickerVisible = true;
      }
    },
    addTime30(strTime) {
      if (strTime.indexOf(":00") != -1) {
        return strTime.replace(":00", ":30");
      } else {
        return strTime
            .replace(strTime.split(":")[0], strTime.split(":")[0] * 1 + 1)
            .replace(":30", ":00");
      }
    },
    pickerClose() {
      this.pickerVisible = false;
    },
    pickerConfirm(e) {
      console.log(e);
      this.formData.priceList[this.priceIndex].priceType = e[0].label;
    },
    dateChoose(e) {
      console.log(this.endTimeIndex);
      this.formData.priceList[this.endTimeIndex].endTime = e;
      this.formData.priceList[
      this.endTimeIndex + 1
          ].startTime = this.formData.priceList[this.endTimeIndex].endTime;
      for (var i = this.endTimeIndex; i < this.formData.priceList.length; i++) {
        var startTime =
            this.formData.priceList[this.endTimeIndex + 1].startTime.replace(
                ":",
                "."
            ) * 1;
        var endTime =
            this.formData.priceList[this.endTimeIndex + 1].endTime.replace(
                ":",
                "."
            ) * 1;
        if (startTime >= endTime) {
          this.formData.priceList.splice(this.endTimeIndex + 1, 1);
          this.formData.priceList[
          this.endTimeIndex + 1
              ].startTime = this.formData.priceList[this.endTimeIndex].endTime;
        }
      }
      this.datePickerVisible = false;
    },
    getTime(num) {
      num = num + "";
      if (num.indexOf(".") != -1) {
        num = num.replace(".5", ":30");
      } else if (num.indexOf(".") == -1) {
        num = num + ":00";
      }
      if (num.length < 3) {
        num = "0" + num;
      }
      return num;
    },
    getRuleTitme() {
      getRulePriceList({id: this.$route.query.id})
          .then((res) => {
            if (res.data && res.data.length > 0) {
              res.data.map((item) => {
                if (item.rangTime) {
                  //还原价格
                  this.priceTypeList[item.priceType].id = item.id;
                  this.priceTypeList[item.priceType].price = item.price * 1;
                  this.priceTypeList[item.priceType].servicePrice =
                      item.servicePrice * 1;

                  var rangTime = JSON.parse(item.rangTime);
                  rangTime.map((it) => {
                    //时间
                    this.formData.priceList.push({
                      priceType: item.priceType,
                      startTime: this.getTime(it.startTime),
                      endTime: this.getTime(it.endTime),
                      classStartTime: "",
                      classEndTime: "",
                    });
                  });
                  this.formData.priceList.sort((a, b) => {
                    return b.endTime - a.endTime;
                  });
                }
              });
              var priceList = this.formData.priceList.sort((a, b) => {
                return parseFloat(a.endTime) - parseFloat(b.endTime);
              });
              console.log(priceList);
            }
          })
          .catch((res) => {
          });
    },
    confimHandler() {
      var c = 0;
      var op = true;
      //严重时间段是否连续
      this.formData.priceList.forEach((item, index) => {
        var startTime = item.startTime.replace(":", ".").replace("30", "5") * 1;
        var endTime = item.endTime.replace(":", ".").replace("30", "5") * 1;

        if (index < this.formData.priceList.length - 1) {
          var startTime2 = this.formData.priceList[index + 1].startTime
              .replace(":", ".")
              .replace("30", "5");
          var endTime2 = this.formData.priceList[index + 1].endTime
              .replace(":", ".")
              .replace("30", "5");

          //时间相同校验
          if (endTime == startTime) {
            this.formData.priceList[index].classEndTime = "error_input";
            this.formData.priceList[index].classStartTime = "error_input";
            Toast("开始时间和截止时间不能相同");
            op = false;
          }
          //开始时间小于结束时间
          if (endTime < startTime) {
            this.formData.priceList[index].classEndTime = "error_input";
            this.formData.priceList[index].classStartTime = "error_input";
            Toast("开始时间不能小于结束时间");
            op = false;
          }

          //时间连续校验
          if (endTime != startTime2) {
            this.formData.priceList[index].classEndTime = "error_input";
            this.formData.priceList[index + 1].classStartTime = "error_input";
            Toast("时间必须连续");
            op = false;
          }
          if (op) {
            this.formData.priceList[index].classEndTime = "";
            this.formData.priceList[index + 1].classStartTime = "";
          }
        }
        c = c + (endTime - startTime);
      });
      if (op) {
        if (c == 24) {
          if (!this.$route.query.createtime) {
            this.addRule();
          } else {
            this.editRule();
          }
        } else {
          Toast("时间必须连续");
        }
      }
    },
    editRule() {
      var priceList = new Array();
      //0:尖 1:峰 2:平 3:谷
      var priceListObj = {};
      for (var i = 0; i < 4; i++) {
        priceListObj["timeRangeList" + i] = {
          id: this.priceTypeList[i].id,
          priceType: i,
          price: this.priceTypeList[i].price,
          servicePrice: this.priceTypeList[i].servicePrice,
          timeRangeList: [],
        };
      }
      this.formData.priceList.forEach((item) => {
        var startTime = item.startTime.replace(":", ".").replace("30", "5") * 1;
        var endTime = item.endTime.replace(":", ".").replace("30", "5") * 1;
        priceListObj["timeRangeList" + item.priceType].timeRangeList.push({
          startTime: startTime,
          endTime: endTime,
        });
      });
      for (var i = 0; i < 4; i++) {
        priceList.push(priceListObj["timeRangeList" + i]);
      }
      var params = {
        id: this.$route.query.id,
        userId: this.$route.query.userId,
        changeName: this.formData.changeName.replace("公众号-", ""),
        priceList: priceList,
      };
      editRule(params).then((res) => {
        if (res.message.code == 0) {
          Toast("修改成功");
          this.$router.replace({
            path: "/admin/rules",
          });
        } else {
          if(res.data){
            Toast(res.data);
          }else if(res.message.message){
              Toast(res.message.message);
          }
          
        }
      });
    },
    addRule() {
      var priceList = new Array();

      //0:尖 1:峰 2:平 3:谷
      var priceListObj = {};
      for (var i = 0; i < 4; i++) {
        priceListObj["timeRangeList" + i] = {
          priceType: i,
          price: this.priceTypeList[i].price,
          servicePrice: this.priceTypeList[i].servicePrice,
          timeRangeList: [],
        };
      }
      this.formData.priceList.forEach((item) => {
        var startTime = item.startTime.replace(":", ".").replace("30", "5") * 1;
        var endTime = item.endTime.replace(":", ".").replace("30", "5") * 1;
        priceListObj["timeRangeList" + item.priceType].timeRangeList.push({
          startTime: startTime,
          endTime: endTime,
        });
      });
      for (var i = 0; i < 4; i++) {
        priceList.push(priceListObj["timeRangeList" + i]);
      }
      var params = {
        userId: this.$route.query.userId,
        changeName: this.formData.changeName,
        priceList: priceList,
      };
      addRule(params).then((res) => {
        if (res.message.code == 0) {
          Toast("添加成功");
          this.$router.replace({
            path: "/admin/rules",
          });
        } else {
          Toast(res.data);
        }
      });
    },
    plusPrice(index) {
      if (this.formData.priceList.length >= 48) {
        Toast("最多只能设置48个时间段哦");
        return;
      }
      let item = JSON.parse(JSON.stringify(this.formData.priceList[index]));
      item.startTime = this.formData.priceList[index].endTime;
      this.formData.priceList.splice(index + 1, 0, item);
      if (item.startTime == "23:00") {
        item.endTime = "23:30";
        this.formData.priceList[index + 1].startTime = "23:00";
        if (index + 1 < this.formData.priceList.length) {
          this.formData.priceList[index + 2].startTime = "23:30";
        }
      }
    },
    minusPrice(index) {
      this.formData.priceList[index - 1].endTime = this.formData.priceList[
          index
          ].endTime;
      this.formData.priceList.splice(index, 1);
    },
    selectFun(index) {
      this.pickerVisible = true;
      this.priceIndex = index;
    },

    switchPicker() {
      this.datePickerVisible = false;
    },
    caches() {
      this.$router.replace({
        path: "/admin/rules",
      });
    },

  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.editruleMain {
  background-color: #F5F5F6;
  min-height: 100%;

  ::v-deep .el-input__inner {
    background-color: #F7F7F7;
    border-radius: 0.0810rem;
  }

  .form-top {
    padding-bottom: 0.3rem;

    ::v-deep .el-form-item {
      flex-wrap: wrap;

      .el-form-item__label {
        width: 100%;
        text-align: left;
        font-weight: bold;
        color: #444444;
      }

      .el-input__suffix {
        //right: 0.2rem;

        .el-input__count {
          font-size: $fontSize_12;

          .el-input__count-inner {
            background-color: transparent;
          }
        }
      }
    }
  }

  .form-cart {
    margin: 0 $divPadding;
    border-radius: $borderRadius;
  }

  .form-item-rule-box {
    padding-bottom: $divPadding;

    &:first-child {
      padding-top: $divPadding;
    }

    &:last-child {
      .form-item-rule_body {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }

    &:nth-child(1) .form-item-rule_label:before {
      background-color: #E22E2E;
    }

    &:nth-child(2) .form-item-rule_label:before {
      background-color: #FB9425;
    }

    &:nth-child(3) .form-item-rule_label:before {
      background-color: #2557FB;
    }

    &:nth-child(4) .form-item-rule_label:before {
      background-color: #25CAE3;
    }

    .form-item-rule_label {
      color: #444444;
      font-weight: bold;
      font-size: 0.3243rem;
      padding-left: 0.3rem;
      position: relative;
      margin-bottom: 0.3rem;

      &:before {
        content: '';
        position: absolute;
        width: 3px;
        height: 70%;
        border-radius: 2rem;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto 0;
      }
    }

    .form-item-rule_body {
      display: flex;
      padding-bottom: $divPadding;
      border-bottom: 1px solid #ECECEC;


      .form-item-rule_item {
        .form-item-rule_item_label {
          color: #888888;
          font-size: 0.3543rem;
          padding-left: 0.3rem;
          padding-bottom: 0.2rem;
        }

        &:first-child {
          .form-item-rule_tem_value {
            padding-right: 0.3rem;
          }
        }

        .form-item-rule_tem_value {
          ::v-deep .el-input__inner {
            border-radius: 0.0810rem;
            font-size: $fontSize_14;
          }
        }
      }
    }
  }

  .tips-box {
    padding: $divPadding;

    .title {
      font-size: 0.3783rem;
      color: #444444;
      font-weight: bold;

      span {
        color: #FF0000;
        margin-right: 0.1rem;
      }
    }

    .desc {
      margin-top: 0.2rem;
      color: #999999;
      font-size: 0.3243rem;
    }
  }

  .form-box-time-box {
    padding: $divPadding;
    background-color: #FFFFFF;

    .time-title-box {
      display: flex;
      color: #888888;
      font-size: 0.3243rem;
      padding-bottom: 0.1rem;

      .item {
        flex: 1;
      }
    }

    .time-item {
      margin-top: 0.3rem;

      .before {
        display: flex;

        .select-key,
        .time-picker {
          display: flex;
          background-color: #F7F7F7;
          border-radius: 0.0810rem;
          padding: 0 0.3rem;
        }

        .select-key {
          justify-content: center;
          width: 2.4324rem;

          ::v-deep .el-select {
            .el-input__inner {
              padding: 0;
              padding-left: 0 !important;
              font-size: 0.3243rem;
              line-height: 0.3rem;
              height: auto;
            }

            .el-input__suffix {
              display: none;
            }
          }

          .label {
            align-self: center;
          }

          .icon {
            margin-left: 0.3rem;
            align-self: center;
            width: 0.1324rem;
            height: 0.1324rem;
          }
        }

        .time-picker {
          //flex: 1;
          margin-left: 0.3rem;
          display: flex;
          position: relative;
          width: 5.5921rem;


          .disabled-item {
            ::v-deep .el-input__inner {
              color: #999 !important;
            }
          }


          .time-picker-item {
            display: flex;
            width: calc(50% - 0.3rem);

            ::v-deep .el-date-editor {
              width: 1rem;
              position: relative;

              .el-input__suffix {
                left: 0;

                .el-input__icon {
                  width: 2rem;
                }
              }


              .el-icon-time {
                display: none;
              }

              .el-input__inner {
                padding: 0;
                padding-left: 0 !important;
                width: 2rem;
                color: #333;
                background-color: transparent;
              }

              .el-input__prefix {
                display: none;
              }
            }

            .icon {
              align-self: center;
              width: 0.2972rem;
              height: 0.2972rem;
              margin-right: 0.2rem;
            }

            .value {
              font-size: 0.3243rem;
            }
          }

          .after-icon {
            position: absolute;
            width: 0.1324rem;
            height: 0.1324rem;
            top: 0;
            bottom: 0;
            margin: auto 0;
            right: 0.3rem;
          }
        }
      }

      .is-one {
        justify-content: flex-end;

        .operate-btn {
          width: 5.621621621621622rem !important;
          margin-right: 0 !important;
          background-color: #F7FBFD !important;

        }
      }

      .after {
        display: flex;
        margin-top: 0.3rem;

        .operate-btn {
          padding: 0.15rem 0.7rem;
          font-size: $fontSize_12;
          border-radius: $borderRadius;
          color: #666666;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-plus {
            margin-right: 0.2rem;
            font-size: $fontSize_10;
          }


          &:nth-child(1) {
            margin-right: 0.3rem;
            width: 2.4324rem;
            background-color: #FFFDF7;
          }

          &:nth-child(2) {
            flex: 1;
            width: 5.621621621621622rem;
            background-color: #F7FBFD;
          }
        }
      }
    }
  }

}

::v-deep .el-icon-arrow-up:before {
  color: #59759f;
}

::v-deep .nut-cell:last-of-type {
  background-image: none;
}

::v-deep .nut-cell {
  background-color: transparent !important;
  padding: 0;

  .nut-cell-left,
  .nut-cell-right {
    padding: 0.2778rem 0;
  }

  .nut-cell-box {
    background-image: linear-gradient(#0b2957, #0b2957);
  }

  .nut-cell-box:first {
    background-image: none !important;
  }

  .nut-cell-title {
    color: #5c6e99;
  }

  .tipmincc {
    margin: 0.2778rem 0;
    color: #6f4128;
    font-size: 0.2778rem;
  }
}

.priceTypeList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

::v-deep .nut-cell:first-of-type .nut-cell-box {
  background-image: none !important;
}

::v-deep .nut-cell:first-of-type {
  background-image: none !important;
}

::v-deep .el-input__icon {
  display: flex;
  align-items: center;
}

label {
  color: #4c6899;
}
</style>
